import BatchIcon from './BatchIcon'

export default BatchIcon
